"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
require("./input.css");
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
} // Ant Design components:
// Custom Turing CSS styles
// MaterialUI icons
// Input component
function Input(props) {
  if (props.number) return /*#__PURE__*/_react["default"].createElement(_antd.InputNumber, props);

  // Defining variables ---
  var disabled = props.disabled ? true : false,
    readOnly = props.disabled ? true : false,
    error = false,
    label = '',
    name = '',
    type = '',
    dense = '',
    placeholder = '',
    defaultValue = '',
    value = '',
    helperTxt = '',
    characterMin = '',
    characterMax = '',
    prefix = '',
    suffix = '',
    iconLeft = '',
    iconRight = '',
    content = [],
    cssWrap = [],
    cssInputHolder = [],
    cssInput = [],
    id = props.id;

  // --- end of Defining variables

  // Assigning values ---

  // default values

  type = 'text';
  cssWrap.push('input-group');
  cssInputHolder.push('input-field-holder');
  cssInput.push('input-field');

  // prop values

  if (props.name) {
    name = props.name;
  }
  if (props.type) {
    type = props.type;
  }
  if (props.dense) {
    dense = props.dense;
    cssWrap.push('has-dense');
    cssInput.push('input-dense');
  }
  if (props.label || props.helperTxt) {
    if (props.label) {
      label = props.required ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "required"
      }, "* "), props.label) : props.label;
    }
    if (props.helperTxt) {
      helperTxt = props.helperTxt;
    }
  }
  if (props.placeholder) {
    placeholder = props.placeholder;
  }
  if (props.value || props.defaultValue) {
    defaultValue = props.defaultValue || props.value;
    value = props.value || props.defaultValue;
  }
  if (props.characterMin) {
    characterMin = props.characterMin;
  }
  if (props.characterMax) {
    characterMax = props.characterMax;
  }
  if (props.prefix) {
    prefix = props.prefix;
    cssWrap.push('has-prefix');
  }
  if (props.suffix) {
    suffix = props.suffix;
    cssWrap.push('has-suffix');
  }
  if (props.iconLeft && props.iconRight) {
    iconLeft = props.iconLeft;
    iconRight = props.iconRight;
    cssInputHolder.push('icon-left-right');
  } else if (props.iconLeft || props.iconRight) {
    if (props.iconLeft) {
      iconLeft = props.iconLeft;
      cssInputHolder.push('icon-left');
    }
    if (props.iconRight) {
      iconRight = props.iconRight;
      cssInputHolder.push('icon-right');
    }
  }
  if (props.disabled) {
    disabled = props.disabled;
    cssWrap.push('disabled');
    cssInput.push('disabled');
  }
  if (props.readOnly) {
    readOnly = props.readOnly;
  }
  if (props.error) {
    error = props.error;
    cssWrap.push('error');
    cssInput.push('error');
  }
  if (props.code) {
    cssWrap.push('code');
    cssInput.push('code');
  }
  // Joining classes to string
  cssWrap = cssWrap.join(' ');
  cssInputHolder = cssInputHolder.join(' ');
  cssInput = cssInput.join(' ');

  // --- end of Assigning values

  // Passing handlers to component
  var handlers = {};
  for (var prop in props) {
    if (typeof props[prop] === "function") Object.assign(handlers, _defineProperty({}, prop, props[prop]));
  }

  // Building component strucutre
  //console.log('handlers',handlers)
  return buildComponent(type, label, name, id, placeholder, readOnly, defaultValue, value, helperTxt, characterMin, characterMax, disabled, error, prefix, suffix, iconLeft, iconRight, cssWrap, cssInputHolder, cssInput, handlers);
}

/* Build compnent strucure - function */

function buildComponent(type, label, name, id, placeholder, readOnly, defaultValue, value, helperTxt, characterMin, characterMax, disabled, error, prefix, suffix, iconLeft, iconRight, cssWrap, cssInputHolder, cssInput, handlers) {
  // if label or helperTxt - create div wrap

  if (label != '' || helperTxt != '') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: cssWrap
    }, createLabel(label), createInput(type, name, id, placeholder, readOnly, disabled, defaultValue, value, prefix, suffix, iconLeft, iconRight, cssInputHolder, cssInput, handlers), createHelperText(helperTxt, characterMin, characterMax));
  } else {
    return createInput(type, name, id, placeholder, readOnly, disabled, defaultValue, value, prefix, suffix, iconLeft, iconRight, cssInputHolder, cssInput, handlers);
  }
}

/* Create Label if set */
function createLabel(label) {
  if (label != '') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "input-name"
    }, label);
  }
}

/* Create Helper text if set */
function createHelperText(helperTxt, characterMin, characterMax) {
  if (characterMax != '') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "input-helper character-counter"
    }, /*#__PURE__*/_react["default"].createElement("span", null, characterMin), /*#__PURE__*/_react["default"].createElement("span", {
      className: "splitter"
    }, "/"), /*#__PURE__*/_react["default"].createElement("span", null, characterMax));
  } else if (helperTxt != '') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "input-helper"
    }, helperTxt);
  }
}

/* Create Input field - and input holder if icon, prefix or suffix is set */
function createInput(type, name, id, placeholder, readOnly, disabled, defaultValue, value, prefix, suffix, iconLeft, iconRight, cssInputHolder, cssInput, handlers) {
  if (iconLeft != '' && iconRight != '') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: cssInputHolder
    }, /*#__PURE__*/_react["default"].createElement(_antd.Input, _extends({
      className: cssInput,
      id: id,
      name: name,
      type: type,
      placeholder: placeholder,
      defaultValue: defaultValue,
      readOnly: readOnly,
      disabled: disabled,
      value: value
    }, handlers)), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      className: "material-icons-round input-icon is-left"
    }, iconLeft), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      className: "material-icons-round input-icon is-right"
    }, iconRight));
  } else if (iconLeft != '' || iconRight != '') {
    if (iconLeft != '') {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: cssInputHolder
      }, /*#__PURE__*/_react["default"].createElement(_antd.Input, _extends({
        className: cssInput,
        id: id,
        name: name,
        type: type,
        placeholder: placeholder,
        defaultValue: defaultValue,
        readOnly: readOnly,
        disabled: disabled,
        value: value
      }, handlers)), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: "material-icons-round input-icon is-left"
      }, iconLeft));
    } else if (iconRight != '') {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: cssInputHolder
      }, /*#__PURE__*/_react["default"].createElement(_antd.Input, _extends({
        className: cssInput,
        id: id,
        name: name,
        type: type,
        placeholder: placeholder,
        defaultValue: defaultValue,
        readOnly: readOnly,
        disabled: disabled,
        value: value
      }, handlers)), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: "material-icons-round input-icon is-right"
      }, iconRight));
    }
  } else if (prefix != '') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: cssInputHolder
    }, /*#__PURE__*/_react["default"].createElement(_antd.Input, _extends({
      className: cssInput,
      id: id,
      name: name,
      type: type,
      placeholder: placeholder,
      defaultValue: defaultValue,
      readOnly: readOnly,
      disabled: disabled,
      value: value
    }, handlers)), /*#__PURE__*/_react["default"].createElement("span", {
      className: "input-prefix"
    }, prefix));
  } else if (suffix != '') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: cssInputHolder
    }, /*#__PURE__*/_react["default"].createElement(_antd.Input, _extends({
      className: cssInput,
      id: id,
      name: name,
      type: type,
      placeholder: placeholder,
      defaultValue: defaultValue,
      readOnly: readOnly,
      disabled: disabled,
      value: value
    }, handlers)), /*#__PURE__*/_react["default"].createElement("span", {
      className: "input-suffix"
    }, suffix));
  } else {
    return /*#__PURE__*/_react["default"].createElement(_antd.Input, _extends({
      className: cssInput,
      id: id,
      name: name,
      type: type,
      placeholder: placeholder,
      defaultValue: defaultValue,
      readOnly: readOnly,
      disabled: disabled,
      value: value
    }, handlers));
  }
}
var _default = exports["default"] = Input;